import { useAppSelector } from '../app/hooks';
import {
    selectCaseHeader,
    selectCaseHeaderLoadingStatus,
    selectCaseHeaderError
} from '../features/caseinfo/logic/Slice';
import { Case } from '../api/cases';


export interface UseCaseInfoDataReturn {
    data: Case | null;
    isLoading: boolean;
    error: string | null;
    hasData: boolean;
}


export const useCaseInfoData = (): UseCaseInfoDataReturn => {
    const caseData = useAppSelector(selectCaseHeader);
    const loadingStatus = useAppSelector(selectCaseHeaderLoadingStatus);
    const error = useAppSelector(selectCaseHeaderError);
  
    const isLoading = loadingStatus === 'pending' || (loadingStatus === 'idle' && !caseData);
  
    return {
      data: caseData,
      isLoading,
      error,
      hasData: !!caseData
    };
};